import { render, staticRenderFns } from "./LaboTable.vue?vue&type=template&id=8aec9540&scoped=true&"
import script from "./LaboTable.vue?vue&type=script&lang=js&"
export * from "./LaboTable.vue?vue&type=script&lang=js&"
import style0 from "./LaboTable.vue?vue&type=style&index=0&id=8aec9540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec9540",
  null
  
)

export default component.exports